import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { WalletProvider } from './context/WalletContext';
import { AuthProvider } from './context/AuthContext';

// Import styles
import './styles/global.css';
import './App.css';

// Import pages
import Home from './pages/Home';
import Marketplace from './pages/Marketplace';
import Profile from './pages/Profile';
import Upload from './pages/Upload';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import GitHubCallback from './pages/GitHubCallback';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  // Add Font Awesome script
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://kit.fontawesome.com/a076d05399.js';
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Create a protected route component
  const ProtectedRoute = ({ children }) => {
    // We'll use localStorage to check if user is logged in for simplicity
    const isAuthenticated = localStorage.getItem('user') !== null;

    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    return children;
  };

  return (
    <Router>
      <AuthProvider>
        <WalletProvider>
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path="/upload" element={
                  <ProtectedRoute>
                    <Upload />
                  </ProtectedRoute>
                } />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/github-callback" element={<GitHubCallback />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </WalletProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
